<template>
	<el-tabs type="border-card">
		<!-- 会员管理页-->
		<el-tab-pane label="会员管理">
			<el-form ref="so" :model="so" label-width="80px" style="margin-left: 80px;">
				<el-form-item label="ID">
					<el-input v-model="so.id" />
				</el-form-item>
				<el-form-item label="会员信息">
					<el-input v-model="so.guanjianci" placeholder="可搜索姓名/昵称/手机号"></el-input>
				</el-form-item>
				<el-form-item label="角色">
					<el-select v-model="so.dengji" placeholder="请选择角色" style="width: 100%;">
						<el-option label="不限角色" value=""></el-option>
						<el-option :label="l.ming" :value="l.id" v-for="l in dengJilie"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="so.zhuagntai" placeholder="请选择状态" style="width: 50%;">
						<el-option label="不限" value=""></el-option>
						<el-option label="正常" value="1"></el-option>
						<el-option label="黑名单" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="annui">
					<el-button type="primary" @click="CSH">搜索</el-button>
					<el-button>导出</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="huiYuanlie" style="width: 100%" current-row-key="i">
				<el-table-column prop="id" label="ID" width="120"></el-table-column>
				<el-table-column label="会员" style="position: relative;">
					<template slot-scope="shu">
						<el-popover trigger="hover" placement="top">
							<el-avatar shape="square" :src="shu.row.fuji_touxiang"></el-avatar>
							<span style="position:absolute; top:1.25rem; left: 3.75rem;color: #428bca;">{{shu.row.fuji_nicheng}}</span>
							<div slot="reference" class="name-wrapper">
								<el-avatar shape="square" :src="shu.row.touxiang"></el-avatar>
								<span style="position:absolute; top:1.25rem; left: 3.75rem;color: #428bca;">{{shu.row.nicheng}}</span>
							</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column prop="xingming" label="姓名" width="100"></el-table-column>
				<el-table-column prop="zhanghao" label="账号" width="120"></el-table-column>
				<el-table-column label="角色" width="120">
					<template slot-scope="shu" v-if="dengJilie_obj[shu.row.dengji]">
						<el-dropdown trigger="click" @command="Gaidengji">
							<span class="el-dropdown-link">
								{{dengJilie_obj[shu.row.dengji].ming}}<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="l in dengJilie" :command="[l.id,shu.row.id,shu.$index]">{{l.ming}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
				<el-table-column prop="youxiaoqi" label="VIP有效期" width="120"></el-table-column>
				<el-table-column prop="jifen" label="余额积分" width="120">
					<template slot-scope="shu">
						<el-tag effect="dark" size="small">余：{{shu.row.yuE}}</el-tag>
						<el-tag effect="dark" type="info" size="small">积：{{shu.row.jiFen}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="shijian" label="时间"></el-table-column>
				<!-- 操作 -->
				<el-table-column label="操作">
					<template slot-scope="shu">
						<el-dropdown trigger="click" @command="Mianbandakai">
							<el-button type="primary">
								操作<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="['huiyuan',shu.row]">会员信息</el-dropdown-item>
								<el-dropdown-item :command="['tuandui',shu.row]">我的团队</el-dropdown-item>
								<el-dropdown-item :command="['chongzhi',shu.row]">充值</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
				<!-- 弹框 -->

			</el-table>
			<el-pagination background layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao"
			 :current-page.sync="so.ye" @current-change="CSH" style="margin-top: 30px;">
			</el-pagination>
		</el-tab-pane>
		<!-- 角色管理列页 -->
		<el-tab-pane label="角色管理">
			<el-table style="width: 100%" :data="dengJilie">
				<el-table-column prop="id" label="ID" width="120" />
				<el-table-column prop="ming" label="角色名称" width="150" />
				<el-table-column label="操作">
					<template slot-scope="shu">
						<el-button type="success" @click="Mianbandakai(['xinzengdengji',shu.row])">编辑</el-button>
						<el-button @click="Dengjishanchu(shu.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 新增角色 -->
			<el-button @click="Mianbandakai(['xinzengdengji'])">新增角色</el-button>
		</el-tab-pane>

		<!-- 会员信息对话框 -->
		<el-drawer title="会员信息" :visible.sync="mianban.huiyuan" direction="rtl">
			<el-form :model="mianban_shu" style="padding: 0 40px;">
				<el-form-item label="账号" label-width="80px">
					<el-input v-model="mianban_shu.zhanghao" />
				</el-form-item>
				<el-form-item label="密码" label-width="80px">
					<el-input v-model="mianban_shu.mima" show-password />
				</el-form-item>
				<el-divider content-position="left"></el-divider>
				<el-form-item label="上级" label-width="80px">
					<el-autocomplete v-model="mianban_shu.fuji_nicheng" :fetch-suggestions="Fujilie" @select="Xuanzeshangji"
					 :trigger-on-focus="false" placeholder="请输入昵称/手机" style="width: 100%;">
						<i class="el-icon-edit el-input__icon" slot="suffix"></i>
						<template slot-scope="{item}">
							<div class="name">{{item.value}}[ID:{{item.id}}]</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-divider content-position="left"></el-divider>
				<el-form-item label="头像" label-width="80px">
					<Shangtu v-model="mianban_shu.touxiang" v-if="mianban.huiyuan"></Shangtu>
				</el-form-item>
				<el-form-item label="昵称" label-width="80px">
					<el-input v-model="mianban_shu.nicheng" />
				</el-form-item>
				<el-form-item label="姓名" label-width="80px">
					<el-input v-model="mianban_shu.xingming" />
				</el-form-item>
				<el-form-item label="性别" label-width="80px">
					<el-radio-group v-model="mianban_shu.xingbie">
						<el-radio label="男">男</el-radio>
						<el-radio label="女">女</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="省市区" label-width="80px">
					<Dizhi v-model="mianban_shu.shengshiqu" v-if="mianban.huiyuan"></Dizhi>
				</el-form-item>
				<el-form-item label="详细地址" label-width="80px" class="el-form-itemt">
					<el-input v-model="mianban_shu.dizhi" />
				</el-form-item>
			</el-form>
			<div class="demo-drawer__footer">
				<el-button @click="mianban.huiyuan=false">关 闭</el-button>
				<el-button type="primary" @click="Mianban_post('huiyuan')">确 定</el-button>
			</div>
		</el-drawer>
		<!-- 我的团队抽屉 -->
		<el-drawer title="推广下线" :visible.sync="mianban.tuandui" direction="rtl" size="50%">
			<!-- <el-divider></el-divider> -->
			<el-table :data="tuanduilie">
				<el-table-column property="id" label="ID" width="120"></el-table-column>
				<el-table-column label="会员" width="250">
					<template slot-scope="shu">
						<el-avatar shape="square" :src="shu.row.touxiang"></el-avatar>
						<span style="position:absolute; top:1.25rem; left: 3.75rem;color: #428bca;">{{shu.row.nicheng}}</span>
					</template>
				</el-table-column>
				<el-table-column label="推荐人" width="250">
					<template slot-scope="shu">
						<el-avatar shape="square" :src="shu.row.fu.touxiang"></el-avatar>
						<span style="position:absolute; top:1.25rem; left: 3.75rem;color: #428bca;">{{shu.row.fu.nicheng}}</span>
					</template>
				</el-table-column>
				<el-table-column property="juese" label="等级" width="100">
					<template slot-scope="shu">
						{{dengJilie_obj[shu.row.dengji].ming}}
					</template>
				</el-table-column>
				<el-table-column property="cengji" label="层级" />
				
			</el-table>
			<el-pagination background layout="total,prev,pager,next,jumper" :total="tuanduizongshu" :page-size="tuanduijitiao"
			 :current-page.sync="tuanduiye" @current-change="Tuandui" style="margin-top: 30px;">
			</el-pagination>
		</el-drawer>
		<!-- 充值对话框 -->
		<el-dialog title="后台充值" :visible.sync="mianban.chongzhi">
			<el-divider></el-divider>
			<el-form :model="mianban_shu">
				<div style="display: flex;">
					<el-form-item label="会员编号:" label-width="80px">
						<span>{{mianban_shu.id}}</span>
					</el-form-item>
					<el-form-item label="昵称:" label-width="80px">
						<span>{{mianban_shu.nicheng}}</span>
					</el-form-item>
					<el-form-item label="姓名:" label-width="80px">
						<span>{{mianban_shu.xingming}}</span>
					</el-form-item>
				</div>
				<el-divider></el-divider>
				<el-form-item label="余额" label-width="80px">
					<el-input placeholder="0.00" :value="mianban_shu.yu_e" :disabled="true" style="width: 30%;" />
					<el-input placeholder="增/减余额:-100" v-model="mianban_shu.jiayu_e" style="width: 30%;margin-left:20px;" />
				</el-form-item>
				<el-form-item label="积分" label-width="80px">
					<el-input placeholder="0.00" :value="mianban_shu.jifen" :disabled="true" style="width: 30%;" />
					<el-input placeholder="增/减积分:-100" v-model="mianban_shu.jiajifen" style="width: 30%;margin-left:20px;" />
				</el-form-item>
				<el-form-item label="操作备注" label-width="80px">
					<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="mianban_shu.shouming" />
				</el-form-item>
			</el-form>
			<el-divider></el-divider>
			<div slot="footer" class="dialog-footer">
				<el-button @click="mianban.chongzhi=false">关 闭</el-button>
				<el-button type="primary" @click="Mianban_post('chongzhi')">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 新增角色 -->
		<el-drawer title="新增角色" :visible.sync="mianban.xinzengdengji" direction="rtl">
			<div class="demo-drawer__content" style="padding: 0px 40px;">
				<el-form :model="mianban_shu">
					<el-form-item label="角色名称" label-width="80px">
						<el-input v-model="mianban_shu.ming" size="small"></el-input>
					</el-form-item>
					<el-form-item :label="(i+1)+'级佣金'" label-width="80px" v-for="(l,i) in mianban_shu.cengji">
						<el-input placeholder="请输入内容" v-model="l.bilie" class="input-with-select" />
					</el-form-item>
					<el-form-item label="会员折扣" label-width="80px">
						<el-input size="small" v-model="mianban_shu.zhekou" placeholder="折扣0到10折，0或为空不打折">
							<template slot="append" size="small">折</template>
						</el-input>
					</el-form-item>
					<el-form-item label="有效期" label-width="80px">
						<el-input size="small" v-model="mianban_shu.youxiaoqi" placeholder="有效期按计算,0或空为永久有效">
							<template slot="append" size="small">天</template>
						</el-input>
					</el-form-item>
					<el-form-item label="升级条件" label-width="80px">
						<el-input size="small" v-model="mianban_shu.tiaojian" placeholder="满多少元升级为此角色；">
							<template slot="append" size="small">元</template>
						</el-input>
					</el-form-item>
				</el-form>
				<div class="demo-drawer__footer">
					<el-button @click="mianban.xinzengdengji= false">取 消</el-button>
					<el-button type="primary" @click="Mianban_post('xinzengdengji')">确 定</el-button>
				</div>
			</div>
		</el-drawer>
	</el-tabs>
</template>

<script>
	let that;
	import Shangtu from '../../zujian/Shangtu.vue'
	import Bianjiqi from '../../zujian/Bianjiqi.vue'
	import Dizhi from '../../zujian/Dizhi.vue'
	export default {
		name: 'Huiyuanguanli',
		components: {
			Shangtu,
			Bianjiqi,
			Dizhi
		},
		data() {
			return {
				huiYuanlie: [],
				zongshu: 0,
				so: {
					ye: 1,
					jitiao: 10,
				},
				dengJilie: [],
				dengJilie_obj: [],
				mianban: {
					chongzhi: false,
					huiyuan: false,
					tuandui: false,
					xinzengdengji: false
				},
				mianban_shu: [],
				dengji: {
					cengji: []
				},
				tuanduilie: [],
				tuanduiye: 1,
				tuanduijitiao: 10,
				tuanduizongshu: 0,
				cengji: 0
			}
		},
		created() {
			that = this;
			this.CSH();
			this.Dengjilie();
			this.Peizhi();
		},
		methods: {
			CSH() {
				this.$post('k=huiyuan', that.so, function(s) {
					that.huiYuanlie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
			Dengjilie() {
				this.$post('k=huiyuan&c=Dengjilie', function(s) {
					that.dengJilie_obj = s.shu;
					that.dengJilie = [];
					for (var i in s.shu) {
						that.dengJilie.push(s.shu[i])
					}

				});
			},
			Gaidengji(e) {
				if (that.huiYuanlie[e[2]].dengji != e[0]) {
					that.huiYuanlie[e[2]].dengji = e[0];
					this.$post('k=huiyuan&c=Xiugai', {
						id: e[1],
						dengji: e[0],
					}, function(s) {});
				}

			},
			Mianbandakai(e) {
				that.mianban[e[0]] = true;
				if (e[1]) {
					that.mianban_shu = e[1];
				} else {
					that.mianban_shu = {};
				}

				if (e[0] == 'tuandui') {
					that.Tuandui(1);
				} else if (e[0] == "xinzengdengji") {
					if (!that.mianban_shu.cengji) {
						this.$set(that.mianban_shu, 'cengji', []);						
					}
					for (var i = 0; i < this.cengji; i++) {
						if (!that.mianban_shu.cengji[i]) {
							that.mianban_shu.cengji.push({
								bilie: 0
							});
						}
					}
					if (that.mianban_shu.cengji.length > this.cengji) {
						that.mianban_shu.cengji.splice(this.cengji, that.mianban_shu.cengji.length);
					}
				}

			},
			Mianban_post(e) {
				if (e == 'huiyuan') {
					this.$post('k=huiyuan&c=Xiugai', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
						}
					});
				} else if (e == 'chongzhi') {
					this.$post('k=huiyuan&c=chongzhi', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
						}
					});
				} else if (e == 'xinzengdengji') {
					this.$post('k=huiyuan&c=xinzengdengji', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.Dengjilie();
						}
					});
				}
				that.mianban[e] = false;
			},
			Fujilie(guanjianci, cb) {
				var lie = [];
				this.$post('k=huiyuan', {
					ye: 1,
					jitiao: 10,
					guanjianci: guanjianci
				}, function(s) {
					if (s.shi == 1) {
						for (var i in s.shu.lie) {
							lie.push({
								id: s.shu.lie[i].id,
								value: s.shu.lie[i].nicheng
							});
						}
					}
					cb(lie);
				});
			},
			Xuanzeshangji(e) {
				that.mianban_shu.fuji_id = e.id;
			},
			Tuandui(e) {
				that.tuanduiye = e;
				this.$post('k=huiyuan&c=tuandui', {
					ye: that.tuanduiye,
					jitiao: 10,
					id: that.mianban_shu.id
				}, function(s) {
					that.tuanduilie = s.shu.lie;
					that.tuanduilzongshu = Number(s.shu.zongShu);
				});
			},
			Peizhi() {
				this.$post('k=peizhi', {
					shui: 'jichupeizhi'
				}, function(s) {
					that.cengji = Number(s.shu.cengji);
				});
			},
			Dengjishanchu(id) {
				this.$post('k=huiyuan&c=shanchudengji', {
					id: id
				}, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.Dengjilie();
					}
				});
			}
		}
	}
</script>
<style scoped>
	
	.el-form-itemt {
		/* margin-bottom: 22px; */
	}

	.el-divider--horizontal {
		display: block;
		height: 1px;
		width: 100%;
		margin: 0 !important;
		margin-bottom: 12px !important;
	}

	.el-drawer__body {
		padding: 0 29px !important;
	}

	.el-form-item__label:first-child {
		text-indent: 32px !important;
	}

	.js_input:first-child {
		margin-left: 10px !important;
	}
	.el-dropdown-link{
		color:#606266;
	}
	.tishi {
		margin-left: 12px;
		color: #737373;
	}

	.demo-drawer__footer {
		display: flex;
		justify-content: center;
	}
</style>
